import { BLACK_HAT, Product, WHEAT_HAT, WHITE_HAT } from '../products';

const greenCrewRecos: Product[] = [
    WHEAT_HAT,
    BLACK_HAT,
    WHITE_HAT,
];

export default greenCrewRecos;